import { render, staticRenderFns } from "./InnovativeTechnology.vue?vue&type=template&id=39f4f434&scoped=true"
import script from "./InnovativeTechnology.vue?vue&type=script&lang=js"
export * from "./InnovativeTechnology.vue?vue&type=script&lang=js"
import style0 from "./InnovativeTechnology.vue?vue&type=style&index=0&id=39f4f434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f4f434",
  null
  
)

export default component.exports